// 导入moment
import moment from "moment";
// 时间戳格式化标准时间格式
const timeFormat = function (timestamp) {
  return moment(timestamp).format("YYYY-MM-DD HH:mm:ss");
};
// 时间戳格式化标准日期格式
const dateFormat = function (timestamp) {
  return moment(timestamp).format("YYYY-MM-DD");
};

// 时间戳格式化标准日期格式
const monthFormat = function (timestamp) {
  return moment(timestamp).format("YYYY-MM");
};
// 时区时间格式化标准时间格式
const zoneDate = function (zoneString) {
  return moment(zoneString).format("YYYY-MM-DD");
};
// 时区时间格式化标准时间格式
const zoneTime = function (zoneString) {
  return moment(zoneString).format("YYYY-MM-DD HH:mm:ss");
};

const customTime = function (Time, format = 'YYYY-MM-DD HH:mm:ss') {
  return moment(Time).format(format || 'YYYY-MM-DD HH:mm:ss');
};

export default {
  timeFormat,
  dateFormat,
  monthFormat,
  zoneDate,
  zoneTime,
  customTime
};
